import { Link } from "react-router-dom";
import { Sprout, Phone, Mail, MapPin } from "lucide-react";
import { useContent } from "../context/ContentContext";

export default function Footer() {
  const { content } = useContent();
  const { contact } = content;
  return (
    <footer className="bg-charcoal text-white/80" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="grid place-items-center w-9 h-9 rounded-sm bg-emerald text-white">
              <Sprout className="w-5 h-5" strokeWidth={2} />
            </span>
            <span className="leading-none">
              <span className="font-display text-lg font-700 text-white block">Legacy</span>
              <span className="text-[10px] tracking-[0.25em] uppercase text-gold">Lawn &amp; Landscape</span>
            </span>
          </div>
          <p className="text-sm leading-relaxed text-white/60">
            Veteran-owned. Family-built. Growing more than lawns — building a legacy.
          </p>
        </div>

        <div>
          <h4 className="text-gold text-xs tracking-[0.2em] uppercase font-600 mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about" className="hover:text-white transition-colors">Our Story</Link></li>
            <li><Link to="/founders" className="hover:text-white transition-colors">Meet the Founders</Link></li>
            <li><Link to="/services" className="hover:text-white transition-colors">Services</Link></li>
            <li><Link to="/gallery" className="hover:text-white transition-colors">Our Work</Link></li>
            <li><Link to="/quote" className="hover:text-white transition-colors">Request a Quote</Link></li>
            <li><Link to="/portal" className="hover:text-white transition-colors">Customer Portal</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-gold text-xs tracking-[0.2em] uppercase font-600 mb-4">Service Area</h4>
          <ul className="space-y-2.5 text-sm">
            {contact.serviceAreas.map((a) => (
              <li key={a} className="flex items-center gap-2">
                <MapPin className="w-3.5 h-3.5 text-emerald" /> {a}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-gold text-xs tracking-[0.2em] uppercase font-600 mb-4">Get in Touch</h4>
          <ul className="space-y-2.5 text-sm">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-emerald" /> {contact.phone}</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-emerald" /> {contact.email}</li>
            <li className="text-white/60">{contact.hours}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Legacy Lawn &amp; Landscape. All rights reserved.</span>
          <span>Proudly veteran-owned &amp; family-built.</span>
        </div>
      </div>
    </footer>
  );
}
